import { TableCell, TableRow, Typography } from "@material-ui/core";
import moment from "moment";
import React from "react";
import { IdentifierMapping } from "../../constants";
import { Employee } from "../../graphql/baseTypes";

type EmployeeKeys = keyof Employee;

interface Props {
  item: Employee;
  labelId: string;
  onClickItem: (id: string) => any;
  columns: Array<{
    id: EmployeeKeys;
    align?: "inherit" | "left" | "center" | "right" | "justify";
  }>;
}

const EmployeeTableItem: React.FC<Props> = ({
  item,
  columns,
  labelId,
  onClickItem,
}) => {
  const KEY = `${item.locationId}#${item.insuranceNumber}`;

  const _handleClick = () => {
    onClickItem(KEY);
  };
  return (
    <TableRow
      hover
      onClick={_handleClick}
      tabIndex={-1}
      style={{
        cursor: "pointer",
      }}
      key={KEY}
    >
      {columns.map((column) => {
        if (column.id === "location") {
          const { name } = item[column.id] || {};

          return (
            <TableCell key={column.id} align={column.align}>
              <Typography variant="body2">{name}</Typography>
            </TableCell>
          );
        } else if (column.id === "patient") {
          const { firstname, lastname, email } = item[column.id] || {};

          return (
            <TableCell key={column.id} align={column.align}>
              <Typography variant="body2">
                {firstname} {lastname} {email}
              </Typography>
            </TableCell>
          );
        } else if (column.id === "identifier") {
          return (
            <TableCell key={column.id} align={column.align}>
              <Typography variant="body2">
                {IdentifierMapping[item[column.id] || "insurance"]}
              </Typography>
            </TableCell>
          );
        } else if (column.id === "address") {
          const { street, zip, city } = item[column.id] || {};

          return (
            <TableCell key={column.id} align={column.align}>
              <Typography variant="body2">
                {street}
                {street && ","} {zip} {city}
              </Typography>
            </TableCell>
          );
        } else if (column.id === "expiresAt") {
          const expiresAt = item[column.id] * 1000;

          return (
            <TableCell key={column.id} align={column.align}>
              <Typography variant="body2">
                {moment(expiresAt).format("LLL")}
              </Typography>
            </TableCell>
          );
        }
        const value = item[column.id];

        return (
          <TableCell key={column.id} align={column.align}>
            <Typography variant="body2">{value}</Typography>
          </TableCell>
        );
      })}
    </TableRow>
  );
};

export default React.memo(EmployeeTableItem);
